import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { pickPrinter, printerUsable } from "@/lib/pickPrinter";
import { useStore } from "@/lib/storeContext";

let cache = null;
let cacheAt = 0;
let inflight = null;
const listeners = new Set();

const fetchPrinters = () => {
  if (!inflight) {
    inflight = api
      .get("/printers")
      .then((r) => {
        cache = Array.isArray(r.data) ? r.data : [];
        cacheAt = Date.now();
        inflight = null;
        return cache;
      })
      .catch(() => {
        inflight = null;
        return cache || [];
      });
  }
  return inflight;
};

export const invalidatePrintersCache = () => {
  cache = null;
  cacheAt = 0;
  listeners.forEach((fn) => {
    try { fn(); } catch (_) { /* ignore */ }
  });
};

export const getPrinters = () => fetchPrinters();

export default function usePrecontoPrinter() {
  const { storeId } = useStore();
  const [state, setState] = useState({ loaded: false, printer: null });

  useEffect(() => {
    let alive = true;
    const load = () => {
      fetchPrinters().then((items) => {
        if (!alive) return;
        const printer = pickPrinter(items, "preconto", storeId) || null;
        setState({ loaded: true, printer });
      });
    };
    load();
    listeners.add(load);
    return () => {
      alive = false;
      listeners.delete(load);
    };
  }, [storeId]);

  return {
    loaded: state.loaded,
    precontoPrinter: state.printer,
    hasPreconto: printerUsable(state.printer),
    gestionaleEnabled: !!(state.printer && state.printer.gestionale_enabled && printerUsable(state.printer)),
  };
}
